import * as tslib_1 from "tslib";
export function isFlagEnabled(flags, condition) {
    if (typeof condition === 'string') {
        return !!flags[condition];
    }
    return condition(flags);
}
export function isAnyFlagEnabled(flags, conditions) {
    return conditions.some(function (flag) { return !!flags[flag]; });
}
export function getEnabledFlagList(flags) {
    return Object.keys(flags).filter(function (flag) { return !!flags[flag]; });
}
/**
 * Converts the features array into features object
 */
export function flagsFromSession(features) {
    if (!features) {
        return {};
    }
    return features.reduce(function (o, feature) {
        var _a;
        return (tslib_1.__assign({}, o, (_a = {}, _a[feature] = true, _a)));
    }, {});
}
function getSubFeaturesObject(source, mainFeature, subFeatures) {
    var _a;
    var subFeaturesObject = (_a = {},
        // main feature has multiple sub-features - if any part is enabled, we consider the main enabled
        _a[mainFeature] = isAnyFlagEnabled(source, subFeatures.concat([mainFeature])),
        _a);
    // but also if the main feature is enabled, all sub-features are enabled
    subFeatures.forEach(function (feature) {
        return (subFeaturesObject[feature] = isAnyFlagEnabled(source, [
            mainFeature,
            feature,
        ]));
    });
    return subFeaturesObject;
}
var actionBarPhase2SubFeatures = [
    'one_click_fave',
    'quick_comment',
    'animated_actions',
    'fave_comment_tooltip',
];
export function addCalculatedFlags(source) {
    return tslib_1.__assign({}, getSubFeaturesObject(source, 'actionbar_phase_2', actionBarPhase2SubFeatures), { 
        // these features are just needed for phase 2 to work right
        tooltips_ui_updates: isAnyFlagEnabled(source, [
            'actionbar_phase_2'
        ].concat(actionBarPhase2SubFeatures)) }, source);
}
//# sourceMappingURL=helpers.js.map